import { getScContent } from '@gc-npm/utils.secure.secure-object-2-perso-cookie';

export const syncLocalSession = () => {
  if (process.env.NEXT_PUBLIC_ENV_NAME !== 'local' || typeof window === 'undefined') {
    return;
  }

  try {
    const raw = window.localStorage.getItem('@secure.j.ts');
    if (!raw) return;

    const persistedInfo = JSON.parse(window.atob(raw));
    if (!persistedInfo?.ts) return;

    // El middleware solo necesita el resumen de personalización, nunca el secure completo.
    const content = getScContent(persistedInfo);
    const value = encodeURIComponent(window.btoa(JSON.stringify(content)));
    const expectedCookie = `sc=${value}`;
    const hasExpectedCookie = () => document.cookie.split(';').some(
      (cookie) => cookie.trim() === expectedCookie,
    );
    if (hasExpectedCookie()) return;

    // Sin dominio explícito para que funcione tanto en 127.0.0.1 como en localhost.
    document.cookie = `${expectedCookie}; Path=/; SameSite=Lax`;
    const entryPaths = ['/fibra-y-movil/', '/fibra-y-movil/productos-recomendados/', '/tv/configurador/'];
    const pathname = `${window.location.pathname.replace(/\/$/, '')}/`;
    if (content.userPo?.FLAGS && hasExpectedCookie() && entryPaths.includes(pathname)) {
      // Repetimos la entrada para que el middleware aplique la redirección con la cookie.
      window.location.reload();
    }
  } catch {
    console.warn('No se ha podido sincronizar la sesión local: revisa el formato de @secure.j.ts.');
  }
};
